import { styled, Box } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  padding         : '20px 40px !important',
  border          : `1.3px solid ${theme.palette.primary.gray3}`,
  borderRadius    : '10px',
  color           : '#231F20',
  boxSizing       : 'border-box',
  backgroundColor : theme.palette.primary.white,
  position        : 'relative',
  height          : 'fit-content',
}));
